import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { useState } from "react";
import { getWarehouseDashboardQrCode } from "../../services/warehouse/Warehouse";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import SchedularModal from "../SchedularModal";
import { useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { formatDate, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
import { DataView } from "primereact/dataview";

const WarehouseDashboardQrCodeList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { recordType } = location.state || {}; // Fallback to prevent undefined errors

  const { storeData, brandProfileData, warehouseData } = getUserData();

  let warehouseId = warehouseData.id;
  let enabledGarmentInspection = brandProfileData.enabledGarmentInspection;

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates

  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [qrCodeData, setQrCodeData] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);
  const [challanSchedularModalVisible, setChallanSchedularModalVisible] =
    useState(false);
  const [challanStatusFilterModalVisible, setChallanStatusFilterModalVisible] =
    useState(false);

  const [schedularDate, setSchedularDate] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("ALL"); // Default to show all orders
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]); // Default to show all orders
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermView, setSearchTermView] = useState(false);

  const [countData, setCountData] = useState("");
  const [sumOfGarmentCount, setSumOfGarmentCount] = useState(0);

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  const initializeVariable = () => {
    setQrCodeData([]);
  };

  const handleCalendarModal = () => {
    setChallanSchedularModalVisible(true);
  };

  const handleFilterModal = () => {
    setChallanStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  useEffect(() => {
    const data = {
      ...(recordType === "UNPROCESSED"
        ? { status: [recordType] }
        : { recordType: recordType }),
      startDate: localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(startDate))),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date(endDate))),
    };
    getWarehouseDashboardData(data);
  }, [schedularDate, selectedStatus]);

  const getWarehouseDashboardData = (data) => {
    getWarehouseDashboardQrCode(warehouseId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setQrCodeData(Res);
          updateTotals(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  const [searchFilterValue, setSearchFilterValue] = useState("");
  const [searchTypeToggle, setSearchTypeToggle] = useState(false);

  const filterOrderInfoList = () => {
    return qrCodeData.filter((item) => {
      const qrCode = item.qrCode?.toLowerCase();
      const matchesSearchTermQrcode = qrCode?.includes(
        searchTerm.toLowerCase()
      );
      return matchesSearchTermQrcode;
    });
  };

  const filteredOrderInfoData = filterOrderInfoList();

  const handleSearchType = () => {
    setSearchTypeToggle(!searchTypeToggle);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const updateTotals = (orders) => {
    const statusTotals = orders.reduce((acc, order) => {
      const existingStatus = acc.find(
        (item) => item.stagePriority === order.stagePriority
      );

      if (existingStatus) {
        existingStatus.orderCount += 1;
      } else {
        acc.push({
          currentStage: order.currentStage,
          stagePriority: order.stagePriority,
          orderCount: 1,
        });
      }
      return acc;
    }, []);
    const totalGarmentCountData = statusTotals.reduce(
      (acc, item) => acc + item.orderCount,
      0
    );

    setCountData(statusTotals);
    setSumOfGarmentCount(totalGarmentCountData);
  };

  const OrderStatusColors = {
    1: "#09B4AA",
    2: "#55BD5A",
    3: "#5D53D8",
    4: "#09B4AA",
    5: "#55BD5A",
    6: "#FF6767",
    7: "#5D53D8",
    8: "#6EA4F5",
    9: "#E89534",
    10: "#a906c2",
    0: "#a906c2",
    null: "#5D53D8",
  };

  const renderPaymentModeButtons = () => {
    return countData.map((item) => (
      <div
        key={item?.stagePriority}
        style={{ backgroundColor: OrderStatusColors[item?.stagePriority] }}
        className="px-3 py-2 border-round-md"
      >
        <p className="text-white text-lg font-bold uppercase">
          {item.orderCount}{" "}
          {item.stagePriority !== null
            ? " - (P - " + item.stagePriority + ")"
            : ""}{" "}
          -{" "}
          {item.stagePriority < 1 || item.stagePriority === null
            ? "No Stage"
            : item?.currentStage?.replace(/_/g, " ")}
        </p>
      </div>
    ));
  };

  
  const handleChallanQrCodeProcess = (item) => {
    navigate("/HandleUnProcessTag", {
      qrCode: item,
    });
  };

  const wareHouseStatusColor = {
    IN_TIME: "#F4C430",
    OUT_TIME: "#F76AA0",
    DEFAULT: "#3EB3E1",
  };

  const itemTemplate = (order, index) => {
    const orderStatusColor =
      wareHouseStatusColor[recordType] || wareHouseStatusColor.DEFAULT;
    const str = order.qrCode;
    const billNo = str.match(/.*(?=OI)/)[0];
    return (
      <div className="flex flex-row">
        <Accordion className="order-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
              fontSize: 10,
            }}
            header={`${index + 1}`}
          >
          </AccordionTab>
        </Accordion>
        <Accordion className="order-flex-accordion">
        <AccordionTab
          key={index}
          style={{
            "--backgroundColor-AccordionTab": orderStatusColor,
            fontSize: 10,
          }}
          header={`${order.qrCode} ${order?.garmentPack ? " | " + order.garmentPack : ""}`}
        >
          <div
            className="cursor-pointer"
            // onClick={() =>
            //    navigate("/OrdersGarmentInfo", {
            //         state: {
            //           bookingOrderId: order.id,
            //           storeCustomerId: order.storeCustomerId,
            //         },
            //       })
            // }
          >
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Garment Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.garmentName.replace(/_/g, " ")}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Store:</p>
                <p className="text-lg font-bold capitalize">
                  {order.storeCode
                    ? order.storeCode?.replace(/_/g, " ")
                    : order.wareHouseStore?.store?.storeName.replace(/_/g, " ")}
                </p>
              </div>
              <div className="col-4 flex">
                <div>
                  <p className="text-base font-semiBold capitalize">
                    Bill No.:
                  </p>
                  <p className="text-lg font-bold capitalize">{billNo}</p>
                </div>
                {enabledGarmentInspection && (
                  <div className="ml-5 cursor-pointer">
                    <i
                      className="pi pi-image"
                      onClick={() =>
                        navigate("/WarehouseGarmentInspectionImages", {
                          state: {
                            QrCodeInfo: order,
                          },
                        })
                      }
                      style={{
                        fontSize: "27px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                )}
              </div>
            </div>

            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Stage Priority:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.stagePriority > 0 ? "P - " + order.stagePriority : ""}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Stage Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.stagePriority > 0 ? order.currentStage : ""}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Job Status:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.stagePriority > 0
                    ? order.jobStatus === "UJ"
                      ? "UnProcess Job"
                      : order.jobStatus === "CJ"
                      ? "Done Job"
                      : order.jobStatus === "NJ"
                      ? "Rec'd. - Not Started"
                      : "OnGoing Job"
                    : ""}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
      </div>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                {recordType === "IN_TIME"
                  ? "Received From Store"
                  : recordType === "OUT_TIME"
                  ? "Sent To Store"
                  : recordType === "UNPROCESSED"
                  ? "UnProcessed Tags"
                  : "Processed Tags"}
              </p>
            </div>
          </div>

          {recordType !== "UNPROCESSED" && (
            <i
              className="pi pi-search"
              onClick={() => setSearchTermView(!searchTermView)}
              style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
            ></i>
          )}
          <div
            onClick={() => handleCalendarModal()}
            className="mx-4 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
          {recordType === "UNPROCESSED" && (
            <div
              onClick={() => handleChallanQrCodeProcess(qrCodeData)}
              className="mx-2 cursor-pointer"
            >
              <img
                src={"Laundy_App_Icons_Gifs/Order_Statuses_icons/PROCESSED.png"}
                style={{ width: 27 }}
              />
            </div>
          )}
        </div>
      </div>

      <div className="mx-4 my-2">
        {countData.length > 0 && (
          <div
            className="flex gap-3 mb-3 pb-1 new-scroll-bar"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
          >
            <div
              style={{ backgroundColor: "#2B70D7" }}
              className="px-3 py-2 border-round-md"
            >
              <p className="text-white text-lg font-bold uppercase">
                {sumOfGarmentCount} - All
              </p>
            </div>

            {renderPaymentModeButtons()}
          </div>
        )}

        {searchTermView && (
          <div className="my-2 mx-1 flex flex-1">
            <div className="flex-1">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-xl"> </InputIcon>
                <InputText
                  placeholder={"Search QrCode"}
                  value={searchTerm}
                  keyboardType={
                    searchFilterValue === "NAME" ? "default" : "numeric"
                  }
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="text-xl flex flex-1 py-1 px-5"
                  style={{ borderRadius: 30 }}
                />
              </IconField>
            </div>

            {searchTerm && (
              <div
                className="flex justify-content-center align-items-center mx-2 cursor-pointer"
                onClick={handleClearSearch}
              >
                <p className="text-3xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            )}
          </div>
        )}
        <div>
          {qrCodeData.length > 0 ? (
            <DataView
              value={filteredOrderInfoData || qrCodeData}
              listTemplate={listTemplate}
              paginator
              rows={20}
            />
          ) : qrCodeData.length === 0 ? (
            <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <p className="text-3xl font-Bold">No Tag Found</p>
          </div>
          ) : (
            <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <p className="text-3xl font-Bold">Tag List is Loading</p>
          </div>
          )}
        </div>

        <SchedularModal
          setSchedularModalVisible={setChallanSchedularModalVisible}
          schedularModalVisible={challanSchedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
          typeOfOrder={""}
        />
      </div>
    </div>
  );
};

export default WarehouseDashboardQrCodeList;
